(() => {
  if (window.__drvReviewsLink) return;
  window.__drvReviewsLink = true;

  const findWidget = () => document.querySelector('[data-drv-rio]:not([hidden])') || document.querySelector('[id^="ReviewsWidget-"]') || document.querySelector('.drv-rxl');

  const scroller = () => {
    const wrap = document.querySelector('.page-wrapper');
    if (wrap && /auto|scroll/.test(getComputedStyle(wrap).overflowY) && wrap.scrollHeight > wrap.clientHeight) return wrap;
    return null;
  };

  const scrollToWidget = (target, pass = 0) => {
    const header = document.querySelector('header-component, header');
    const offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    const behavior = pass === 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto';
    const wrap = scroller();
    const from = wrap ? wrap.getBoundingClientRect().top : 0;
    const miss = target.getBoundingClientRect().top - from - offset;
    if (pass > 0 && Math.abs(miss) < 8) return;
    if (wrap) {
      wrap.scrollTo({ top: wrap.scrollTop + miss, behavior });
    } else {
      window.scrollTo({ top: window.scrollY + miss, behavior });
    }
    if (pass < 3) setTimeout(() => scrollToWidget(target, pass + 1), behavior === 'smooth' ? 1600 : 400);
    if (pass > 0) return;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const cardStars = event.target.closest('[data-drv-reviews-href]');
    if (cardStars) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = cardStars.dataset.drvReviewsHref;
      return;
    }
    const link = event.target.closest('[data-drv-reviews-link]');
    if (!link) return;
    const target = findWidget();
    if (!target) return;
    event.preventDefault();
    scrollToWidget(target);
  });

  const RATING_TTL = 600000;
  const ratings = new Map();
  const getRating = (skus) => {
    if (ratings.has(skus)) return ratings.get(skus);
    const key = 'drv-rio:' + skus;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && Date.now() - saved.t < RATING_TTL) {
        const hit = Promise.resolve(saved);
        ratings.set(skus, hit);
        return hit;
      }
    } catch (e) {}
    const store = (window.Shopify && window.Shopify.shop) || 'drvegan.myshopify.com';
    const url = 'https://api.reviews.io/product/review?per_page=1&store=' + encodeURIComponent(store) + '&sku=' + encodeURIComponent(skus);
    const req = fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const a = d && d.stats ? Number(d.stats.average) : 0;
        const c = d && d.stats ? Number(d.stats.count) : 0;
        if (!c) return null;
        const out = { a, c, t: Date.now() };
        try { sessionStorage.setItem(key, JSON.stringify(out)); } catch (e) {}
        return out;
      })
      .catch(() => null);
    ratings.set(skus, req);
    return req;
  };

  const paint = (el, r) => {
    const value = (Math.round(r.a * 10) / 10).toFixed(1);
    const count = '(' + r.c + ')';
    const full = Math.floor(r.a);
    el.querySelectorAll('.drv-pdp__rating-num, .drv-pcard__rating-value, .drv-hprod__rating-value, .drv-bundle__rating-num').forEach((n) => { n.textContent = value; });
    el.querySelectorAll('.drv-pdp__rating-count, .drv-pcard__rating-count, .drv-hprod__rating-count, .drv-bundle__rating-count').forEach((n) => { n.textContent = count; });
    el.querySelectorAll('.drv-pdp__stars, .drv-bundle__stars').forEach((s) => s.style.setProperty('--drv-rating', r.a));
    el.querySelectorAll('.drv-pcard__stars, .drv-hprod__stars').forEach((s) => {
      s.style.setProperty('--drv-rating-full', full);
      s.style.setProperty('--drv-rating-part', (r.a - full).toFixed(4));
    });
    if (el.classList.contains('drv-pdp--rating')) {
      document.querySelectorAll('[data-drv-satc-rating]').forEach((n) => { n.hidden = false; });
      document.querySelectorAll('.drv-satc__rating-num').forEach((n) => { n.textContent = value; });
      document.querySelectorAll('.drv-satc__rating-count').forEach((n) => { n.textContent = count; });
      document.querySelectorAll('[data-drv-satc-rating] .drv-pdp__stars').forEach((s) => s.style.setProperty('--drv-rating', r.a));
    }
  };

  const live = (el) => {
    const skus = el.dataset.drvRioSku;
    if (!skus || el.dataset.drvRioDone) return;
    el.dataset.drvRioDone = '1';
    getRating(skus).then((r) => {
      const pending = el.classList.contains('drv-rio-pending') ? [el] : [...el.querySelectorAll('.drv-rio-pending')];
      if (!r) {
        pending.forEach((p) => { p.hidden = true; });
        return;
      }
      paint(el, r);
      pending.forEach((p) => p.classList.remove('drv-rio-pending'));
    });
  };

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); live(e.target); } });
      }, { root: scroller(), rootMargin: '600px 0px' })
    : null;
  const watch = () => {
    document.querySelectorAll('[data-drv-rio-sku]:not([data-drv-rio-seen])').forEach((el) => {
      el.dataset.drvRioSeen = '1';
      if (io) io.observe(el);
      else live(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; watch(); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (window.location.hash !== '#reviews') return;
  let tries = 0;
  const wait = () => {
    const target = findWidget();
    if (target && target.offsetHeight > 100) {
      scrollToWidget(target);
      return;
    }
    tries += 1;
    if (tries < 40) setTimeout(wait, 250);
  };
  window.addEventListener('load', wait);
})();
